import Api from "./index"

const getRepose = async () => {
    const response = await Api.get("/repos");
    return response.data;
}

const getUsers = async () => {
    const response = await Api.get("/users");
    return response.data;
}

const searchUsers = async (query) => {
    const response = await Api.get(`/search/users?q=${query}`);
    return response.data;
}
const getUserInfo = async (username) => {
    const response = await Api.get(`/users/${username}`);
    return response.data;
}

const getUserRepositories = async (username) => {
    const response = await Api.get(`/users/${username}/repos`);
    return response.data;
}
const getRepoCommitActivity = async (username, repo) => {
    const response = await Api.get(`/repos/${username}/${repo}/stats/commit_activity`);
    return {data: response.data, status: response.status};
}
const getRepoContributors = async (username, repo) => {
    const response = await Api.get(`/repos/${username}/${repo}/contributors`);
    return response.data;
}

export const Github = {
    getRepose,
    searchUsers,
    getUsers,
    getRepoCommitActivity,
    getUserRepositories,
    getRepoContributors,
    getUserInfo,
}
